import React from "react";
import Banner from "../Components/Banner";

function Home() {
  return (
    <div>
      <Banner />
    </div>
  );
}

export default Home;
